export default "__VITE_ASSET__1b0fadb0__"